/* eslint-disable camelcase */
import { createNewInventoryPaymentControl, doDeleteElement, inventoryControls } from './element';
import { saveCtrl, resetCtrl, editColProp } from '../reducers/builder';

export const doSaveCtrl = (value, id, prop, key) => (dispatch, getState) => {
  const { activePage: page } = getState().builder.present;

  dispatch(
    saveCtrl({
      value,
      page,
      id,
      prop,
      key,
    })
  );
};

export const doResetControl = (control) => (dispatch, getState) => {
  const { activePage: page } = getState().builder.present;
  dispatch(
    resetCtrl({
      control,
      page,
    })
  );
};

export const doEditColProp = (colIndex, id, value, prop, isTableProp) => (dispatch, getState) => {
  const { activePage: page } = getState().builder.present;
  dispatch(
    editColProp({
      colIndex,
      id,
      page,
      value,
      prop,
      isTableProp,
    })
  );
};

export const updateInventoryPaymentControl = () => (dispatch) => {
  const { inventory_payment, inventory_field } = dispatch(inventoryControls());
  const { accept_inventory_payment, inventory_payment_type, currency } = inventory_field.props;

  if (accept_inventory_payment) {
    if (inventory_payment) {
      const { internal_id, type, props } = inventory_payment;

      if (inventory_payment_type && inventory_payment_type !== type) {
        dispatch(createNewInventoryPaymentControl(inventory_payment_type, currency));
        return dispatch(doDeleteElement(inventory_payment, null));
      }

      if (currency !== props.currency) dispatch(doSaveCtrl(currency, internal_id, 'currency'));
    } else if (inventory_payment_type) {
      dispatch(createNewInventoryPaymentControl(inventory_payment_type, currency));
    }
  } else if (inventory_payment) {
    dispatch(doDeleteElement(inventory_payment, null));
  }
};
